module.exports = __webpack_public_path__ + "static/femme-cercle-52a69924cf8062c68be00d03ec0f2e3b.png";